export default "__VITE_ASSET__C855NnOJ__"